import React from 'react';
import { useIntl } from 'react-intl';

import tablet from '../../../assets/additional-image/tablet.png';
import {
  HeaderWrapper,
  ProgressBar,
  ProgressBarWrapper,
  ProgressColumn,
  ProgressTitle,
  TabletImage
} from './style';

type Props = {
  completedSteps: number;
};

export const CheckListHeader = ({ completedSteps }: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <HeaderWrapper>
      <ProgressColumn>
        <ProgressTitle>{intl.formatMessage({ id: 'check-list.head-element.title' })}</ProgressTitle>
        <ProgressBarWrapper>
          <ProgressBar progress={(100 / 9) * completedSteps} />
        </ProgressBarWrapper>
      </ProgressColumn>
      <TabletImage src={tablet} />
    </HeaderWrapper>
  );
};
